import PropTypes from 'prop-types';
export default {
    id: PropTypes.number,
    // avatar of the segment creator to be displayed in collapsable header
    avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // The name of the contributor to be displayed on the row
    creatorName: PropTypes.string,
    // The number of litter pieces displayed against the contributor
    litterCount: PropTypes.string,
    // The start date that indicates the day which the segment commenced
    date: PropTypes.string,
    // The duration of the segment to be displayed in minutes / hours / seconds
    duration: PropTypes.string,
    // The distance travelled in the segment to be displayed in meters
    distance: PropTypes.string,
    // the child component to render under the maps column when the card row is expanded
    mapContent: PropTypes.node,
    // the child component to render under the tags column when the card row is expanded
    tagsContent: PropTypes.object,
    // this indicates whether the current segment is active or not
    isActive: PropTypes.bool,
    activeSegmentId: PropTypes.number,
    title: PropTypes.string,
    // category of location where segment was initiated
    landInfo: PropTypes.object,
};
